export default function Rabbitmq(props: any) {

  return (
    <iframe
        id="inlineFrameExample"
        title="Inline Frame Example"
        width="100%"
        height="100%"
        src="/rabbitmq"
        style= {{border: 0}}
      />
  )
}